import { ChangeDetectionStrategy, Component, Inject, Input, Optional } from '@angular/core';
import { Address } from '@vsolv/core/address/domain';
import { GOOGLE_MAP_CONFIG, GoogleMapConfig } from '../../GoogleMapConfig';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-map',
  templateUrl: './map.component.html',
  standalone: false,
})
export class MapComponent {
  constructor(@Optional() @Inject(GOOGLE_MAP_CONFIG) config: GoogleMapConfig) {
    this.googleMapsKey = config.apikey;
  }

  googleMapsKey: string | null;

  @Input() address: Address.Model | null = null;
}
